import { SORTING_OPTIONS_V2_TO_V3 } from '@hotjar/recordings/src/constants/sorting-options';

/**
 * Converts a sortBy identifier string from the old format to the new format that the new endpoint accepts.
 *
 * This is needed mainly because, our columns in the FE are named according to ES (old).
 * But some of them have different names for the v3 CH endpoint (new).
 *
 * TODO: Once ES is dropped, we can cleanup by giving all columns the new names, and removing this function.
 *
 * @param sortByV2 The sortBy identifier string.
 * @returns sortByV3 The sortBy identifier string in the new format.
 */
export function convertSortByV2ToV3(sortByV2: string | null): string | null {
  // Begin by assuming it's the same value.
  let sortByV3 = sortByV2;

  // We remap some column names if needed.
  if (sortByV2) {
    const sortByColumn = sortByV2.replace(/^-/, '');
    if (SORTING_OPTIONS_V2_TO_V3[sortByColumn]) {
      sortByV3 = sortByV2.replace(sortByColumn, SORTING_OPTIONS_V2_TO_V3[sortByColumn]);
    }
  }

  /* Temporary workaround for the engagement experiment. There's no `engagement_score` sorting option, but sorting by relevance gives the same results. */
  if (sortByV2 && sortByV2?.includes('engagement_score')) {
    sortByV3 = sortByV2.replace('engagement', 'relevance');
  }

  return sortByV3;
}
